import { type ModerationDataSource } from '../../data/moderation.data-source'
import { type FlaggingRule } from '../models/moderation.model'

export class GetFlaggingRulesInteractor {
  constructor(private readonly dataSource: ModerationDataSource) {}

  async execute(): Promise<FlaggingRule[]> {
    return this.dataSource.getRules()
  }
}
